import type { RefObject } from 'react';
import useEventListener from './useEventListener';

const useOnClickOutside = (
  callback: (e: Event) => void,
  elRefs: RefObject<Element | null> | RefObject<Element | null>[]
) => {
  const handleOutsideClick = (e: Event) => {
    const innerElRefs = Array.isArray(elRefs) ? elRefs : [elRefs];
    const isClickInside = innerElRefs.some((ref) => ref.current?.contains(e.target as Node));

    if (!isClickInside) callback(e);
  };

  // The `useCapture` arg is set to `true` to ensure the event will dispatch
  // even if the target stops the event from bubbling.
  useEventListener(document, 'click', handleOutsideClick, {
    useCapture: true,
  });
};

export default useOnClickOutside;
